import { createSlice } from '@reduxjs/toolkit';
import {
    getAllUserBuyer,
    getAllUserSupplier,
    getAllPorts,
    getAllRfq,
    getAllVessels,
    getAllVesselsSupplier,
    getAllAgents,
    getAllBrokers,
    getAllSuppliersForPort,
    getLiveprice,
    getCreditApproval,
    getDealFinancingSupplierDetails,
    getSupplierCreditCheck,
    getComplianceCheck,
    getVesselDetails,
    getRfqDetails,
    getBidList,
    getChatGroupAction,
    getAllTransactionByRole,
    getProductList,
    getAllBrokerAssociatedBuyer,
    productsforbroker,
    getAgentList,
    fetchSuppliersByPortandProducts,
    getBrokerDashboardStats,
    getBrokerStats,
    getAllOpsBrokers,
    createRfq,
    updateRfq,
    getlivepricefortopports,
} from '../actions/rfqManagementApi';

const resolveSortItemStatus = (payload) => {
    const hasActive = payload.some((item) => item.includes('Active'));
    const hasClosed =
        payload.some((item) => item.includes('Closed')) ||
        payload.some((item) => item.includes('Inactive'));
    const hasCancelled = payload.some((item) => item.includes('Cancelled'));

    const selectedStatusCount = [hasActive, hasClosed, hasCancelled].filter(Boolean).length;
    if (selectedStatusCount !== 1) {
        return null;
    }
    if (hasActive) {
        return 'active';
    }
    if (hasClosed) {
        return 'inactive';
    }
    if (hasCancelled) {
        return 'cancelled';
    }
    return null;
};

const resolveSortBrokerType = (payload) => {
    const hasAssisted = payload.some((item) => item.includes('assisted'));
    const hasSelfManaged = payload.some((item) => item.includes('self_managed'));
    if (hasAssisted && hasSelfManaged) {
        return 'all';
    }
    if (hasAssisted) {
        return 'assisted';
    }
    if (hasSelfManaged) {
        return 'self_managed';
    }
    return 'all';
};

export const rfqManageSlice = createSlice({
    name: 'rfqManageMent',
    initialState: {
        isLoading: false,
        error: null,
        allBuyer: [],
        allSupplier: [],
        portList: [],
        getAllRfqList: [],
        nextPageDetailAllRfq: {},
        prevPageDetailAllRfq: [],
        rfqMilestones: {},
        allVessels: [],
        allVesselsSupplier:[],
        allAgents: [],
        allBrokers: [],
        allSuppliersForPort: [],
        livePrice: [],
        creditApprovalDetails: {},
        supplierCreditCheck: {},
        dFSupDetails: {},
        complianceCheck: {},
        vesselDetails: [],
        rfqIdDetails: null,
        bidList: [],
        sortItemStatus: null,
        sortItemExpiry: null,
        chatGroups: null,
        filteredTransactionsByRole: [],
        hasPortNext: false,
        nextPortCursor: null,
        portListForSearch: [],
        allProductList: [],
        fetchedPort: [],
        allBrokerAssociatedBuyer: [],
        productListForBroker: [],
        agentList: [],
        suppliersByPortandProducts: [],
        brokerDashboardStats: {},
        brokerStats: {},
        allOpsBroker: [],
        sortBrokerType: 'all',
        nextPageDetailAllBroker: {},
        prevPageDetailAllBroker: [],
        rfqRequestUlId: '',
        isUpdating: false,
        rfqTimestamp: '',
        livePricePortList: [],
    },
    reducers: {
        updatePrevPageAllRfq: (state, action) => {
            state.prevPageDetailAllRfq = action.payload;
        },
        updatePrevPageAllBroker: (state, action) => {
            state.prevPageDetailAllBroker = action.payload;
        },
        getSortItemValue: (state, action) => {
            if (!Array.isArray(action.payload)) {
                state.sortItemStatus = null;
                state.sortBrokerType = null;
            } else {
                const hasERfqExpiry = action.payload.includes('RFQ Expiry Time');
                state.sortItemStatus = resolveSortItemStatus(action.payload);
                state.sortItemExpiry = hasERfqExpiry ? 'rfq_expiry' : null;
                state.sortBrokerType = resolveSortBrokerType(action.payload);
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllUserBuyer.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllUserBuyer.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allBuyer = action.payload?.payload || [];
            })
            .addCase(getAllUserBuyer.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllUserSupplier.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllUserSupplier.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allSupplier = action.payload.payload;
            })
            .addCase(getAllUserSupplier.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllPorts.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllPorts.fulfilled, (state, action) => {
                state.isLoading = false;
                const transformedOptions = action.payload?.payload?.map((item) => ({
                    name: item.name,
                    value: item.ulid,
                }));
                // Keep backend order
                state.portList = transformedOptions;
                const sortedSearchList = action.payload?.optionsList?.map((item) => ({
                    ...item,
                    name: item.name,
                    value: item.ulid,
                }));
                state.portListForSearch = sortedSearchList;
                state.hasPortNext = action.payload.has_next;
                state.nextPortCursor = action.payload.next_cursor;
            })
            .addCase(getAllPorts.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllRfq.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAllRfq.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getAllRfqList = action.payload?.payload;
                state.nextPageDetailAllRfq = action.payload?.nextPage;
                state.rfqMilestones = action.payload?.milestone_count;
            })
            .addCase(getAllRfq.rejected, (state, action) => {
                state.isLoading = false;
                state.getAllRfqList = [];
                state.rfqMilestones = {};
            })
            .addCase(getAllVessels.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllVessels.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allVessels = action.payload;
            })
            .addCase(getAllVessels.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllVesselsSupplier.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllVesselsSupplier.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allVesselsSupplier = action.payload;
            })
            .addCase(getAllVesselsSupplier.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllAgents.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllAgents.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allAgents = action.payload;
            })
            .addCase(getAllAgents.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllBrokers.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllBrokers.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allBrokers = action.payload;
            })
            .addCase(getAllBrokers.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllSuppliersForPort.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllSuppliersForPort.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allSuppliersForPort = action.payload;
            })
            .addCase(getAllSuppliersForPort.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getLiveprice.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getLiveprice.fulfilled, (state, action) => {
                state.isLoading = false;
                state.livePrice = action.payload;
            })
            .addCase(getLiveprice.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getCreditApproval.fulfilled, (state, action) => {
                state.creditApprovalDetails = action.payload;
            })
            .addCase(getDealFinancingSupplierDetails.fulfilled, (state, action) => {
                state.dFSupDetails = action.payload;
            })
            .addCase(getSupplierCreditCheck.fulfilled, (state, action) => {
                state.supplierCreditCheck = action.payload;
            })
            .addCase(getComplianceCheck.fulfilled, (state, action) => {
                state.complianceCheck = action.payload;
            })
            .addCase(getVesselDetails.fulfilled, (state, action) => {
                state.vesselDetails = action.payload;
            })
            .addCase(getRfqDetails.fulfilled, (state, action) => {
                state.rfqIdDetails = action.payload.payload;
                state.fetchedPort = action.payload.selectedPort;
            })
            .addCase(getRfqDetails.rejected, (state, action) => {
                state.rfqIdDetails = null;
            })
            .addCase(getBidList.fulfilled, (state, action) => {
                state.bidList = action.payload;
            })
            .addCase(getBidList.rejected, (state, action) => {
                state.bidList = [];
            })
            .addCase(getChatGroupAction.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getChatGroupAction.fulfilled, (state, action) => {
                state.isLoading = false;
                state.chatGroups = action.payload;
            })
            .addCase(getChatGroupAction.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getAllTransactionByRole.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllTransactionByRole.fulfilled, (state, action) => {
                state.isLoading = false;
                state.filteredTransactionsByRole = action.payload;
            })
            .addCase(getAllTransactionByRole.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getProductList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getProductList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allProductList = (action.payload || []).map((el) => ({
                    ...el,
                    label: el.name,
                    value: el.ulid,
                }));
            })
            .addCase(getProductList.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getAllBrokerAssociatedBuyer.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllBrokerAssociatedBuyer.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allBrokerAssociatedBuyer = action.payload;
            })
            .addCase(getAllBrokerAssociatedBuyer.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(productsforbroker.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(productsforbroker.fulfilled, (state, action) => {
                state.isLoading = false;
                state.productListForBroker = action.payload;
            })
            .addCase(productsforbroker.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getAgentList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAgentList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.agentList = action.payload;
            })
            .addCase(getAgentList.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(fetchSuppliersByPortandProducts.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchSuppliersByPortandProducts.fulfilled, (state, action) => {
                state.isLoading = false;
                state.suppliersByPortandProducts = action.payload;
            })
            .addCase(fetchSuppliersByPortandProducts.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getBrokerDashboardStats.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getBrokerDashboardStats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.brokerDashboardStats = action.payload;
            })
            .addCase(getBrokerDashboardStats.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(createRfq.pending, (state) => {
                state.isUpdating = true;
            })
            .addCase(createRfq.fulfilled, (state, action) => {
                state.isUpdating = false;
                const isRfqUlidPresent = (state.getAllRfqList || []).some(
                    (item) => item.rfq_ulid === action.payload.payload
                );
                if (!action.payload.isEdit && !isRfqUlidPresent) {
                    state.rfqRequestUlId = action.payload.payload;
                }
                state.rfqTimestamp = action.payload.timestamp;
            })
            .addCase(createRfq.rejected, (state, action) => {
                state.isUpdating = false;
            })
            .addCase(updateRfq.pending, (state) => {
                state.isUpdating = true;
            })
            .addCase(updateRfq.fulfilled, (state, action) => {
                state.isUpdating = false;
            })
            .addCase(updateRfq.rejected, (state, action) => {
                state.isUpdating = false;
                state.isLoading = false;
            })
            .addCase(getBrokerStats.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getBrokerStats.fulfilled, (state, action) => {
                state.brokerStats = action.payload;
            })
            .addCase(getBrokerStats.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getAllOpsBrokers.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllOpsBrokers.fulfilled, (state, action) => {
                state.allOpsBroker = action.payload;
                state.nextPageDetailAllBroker = action.payload?.nextPage;
            })
            .addCase(getAllOpsBrokers.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getlivepricefortopports.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getlivepricefortopports.fulfilled, (state, action) => {
                state.livePricePortList = action.payload;
            })
            .addCase(getlivepricefortopports.rejected, (state, action) => {
                state.isLoading = false;
            });
    },
});
export const { updatePrevPageAllRfq, getSortItemValue, updatePrevPageAllBroker } = rfqManageSlice.actions;
export default rfqManageSlice.reducer;
